export default {
  mustBeChildField: true,
  canBeChildField: true,
  canBeParentField: false,
  canBeChildOfFieldTypes: ["contact", "reference"]
};
